//Build-In
import React, { Suspense, Fragment } from "react";
//External
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import { Loader, Types } from "react-loaders";
import LoadingOverlay from "react-loading-overlay-ts";
import PropTypes from "prop-types";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import { connect } from "react-redux";
import PhoneIcon from "@mui/icons-material/Phone";
import FavoriteIcon from "@mui/icons-material/Favorite";
import PersonPinIcon from "@mui/icons-material/PersonPin";
import PhoneMissedIcon from "@mui/icons-material/PhoneMissed";
import { Card, Container } from "@mui/material";
import { CSSTransition, TransitionGroup } from "react-transition-group";
import { Col, Row } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark } from "@fortawesome/free-solid-svg-icons";
import cx from "classnames";
//Internal
import NoRecord from "../../Common/NoRecord";
import requestApi from "../../services/requestApi.service";
import Common from "../../Common/Common";
import FormHeader from "./FormHeader";
import {
  compareBy,
  getFormDetails,
  getSessionValue,
  populateFormDetails,
  showToast,
  getListFields,
  getProfileFields,
  prepareDefaultValueList,
  handleErrorResponse,
} from "../../Common/Appcommon";
import { setFormDetails } from "../../reducers/ThemeOptions";
import DataRow from "./DataRow";
import ConfigView from "./ConfigView";
import Form from "./Form";
import DeleteConfirm from "../../Common/DeleteConfirm";
import BasicLead from "./Basic";
import MassUpdate from "../../Common/MassUpdate";
import CratioConfigModel from "../Common/CratioConfigModel";
import CratioToggle from "../Common/CratioToggle";
import SearchPanel from "../Search/SearchPanel";

class Leads extends React.Component {
  formname = getSessionValue("leadformname");
  formDetail = [];
  selectedTemplate = [];
  hasMore = true;
  lastScrollUpdated = "";
  predefinedConditionArr = {
    //0 : "table_52@Planned_Start@is@Not Empty",
    1: "table_52@Planned_Start@is@Today",
    2: "table_52@Planned_Start@is@Overdue",
    3: "table_52@Planned_Start@is@Future",
  };
  searchStr = "";
  constructor(props) {
    super(props);
    let { formDetails, setFormDetails } = this.props;
    this.state = {
      formDetails: [],
      templates: [],
      selectedTemplate: [],
      formData: [],
      tabValue: 0,
      listFields: [],
      fieldsSorting: [],
      massSelect: [],
      page: 1,
      limit: 50,
      totalCount: 200,
      deleteConfirmModal: false,
      nestedModal: false,
      closeAll: false,
      forceErrorStr: "",
      showLoader: false,
      dataRow: {},
      isRowSelected: false,
      profileFields: [],
      isOpen: false,
      isMassUpdate: false,
      isSearchOpen: false,
      matchAll: true,
      manualSearchStr: "",
    };
    this.loadMore = this.loadMore.bind(this);
    this.toggleModal = this.toggleModal.bind(this);
    this.toggleNestedModal = this.toggleNestedModal.bind(this);
    this.toggleAllModal = this.toggleAllModal.bind(this);
    this.toggleSearchModal = this.toggleSearchModal.bind(this);
    this.searchOKCB = this.searchOKCB.bind(this);
    this.searchClickCB = this.searchClickCB.bind(this);
    this.searchCancelCB = this.searchCancelCB.bind(this);
    this.toggleMatchAll = this.toggleMatchAll.bind(this);
    this.searchActionCB = false;
  }

  async toggleModal() {
    this.setState({
      deleteConfirmModal: !this.state.deleteConfirmModal,
    });
  }

  async toggleNestedModal() {
    this.setState({
      nestedModal: !this.state.nestedModal,
      closeAll: false,
    });
  }
  async toggleAllModal() {
    this.setState({
      deleteConfirmModal: false,
      nestedModal: false,
      closeAll: false,
      massSelect: [],
    });
  }
  async toggleSearchModal() {
    this.setState({
      toggleSearchModal: !this.state.toggleSearchModal,
    });
  }
  async toggleMatchAll() {
    this.setState({
      matchAll: !this.state.matchAll,
    });
  }
  async searchOKCB() {
    if (this.searchActionCB) {
      let isValidSearch = await this.searchActionCB("validateInput");
      if (!isValidSearch) {
        let searchString = await this.searchActionCB("getSearchString", {
          modeOfSearch: this.state.matchAll ? "AND" : "OR",
        });
        this.state.manualSearchStr = searchString;
        this.loadFormData(true, true, true);
        this.toggleSearchModal();
      }
      //console.log("Response receoived-",response);
    }
  }
  async searchClickCB(callback) {
    this.searchActionCB = callback;
  }
  async searchCancelCB() {
    await this.toggleSearchModal();
  }

  componentDidMount = async () => {
    this.setState({
      showLoader: true,
    });
    await this.populateFormDetail();
    await this.getLeadFormDetails();
    await this.loadFormData();
    let profileFields = await getProfileFields();
    this.setState({
      showLoader: false,
      profileFields,
    });
  };

  componentWillMount() {
    window.addEventListener("scroll", this.loadMore);
  }

  componentWillUnmount() {
    window.removeEventListener("scroll", this.loadMore);
  }

  async loadMore() {
    if (
      this.state.formData != undefined &&
      this.state.formData.length < this.state.totalCount
    ) {
      if (
        window.innerHeight + document.documentElement.scrollTop ===
          document.scrollingElement.scrollHeight &&
        this.hasMore
      ) {
        if (
          this.lastScrollUpdated == "" ||
          +this.lastScrollUpdated < +Math.floor(Date.now() / 1000)
        ) {
          this.lastScrollUpdated = Math.floor(Date.now() / 1000);

          let newPage = this.state.page;
          newPage = +newPage + 1;
          this.setState({ page: newPage });
          await this.loadFormData(false);
        }
      }
    }
  }

  populateFormDetail = async () => {
    this.formDetail = await getFormDetails(
      this.formname,
      this.props["formDetails"]
    );
    if (this.formDetail.length == 0) {
      this.formDetail = await populateFormDetails(this.formname);
      let newFormDetails = {};
      newFormDetails[this.formname] = this.formDetail;
      await setFormDetails([newFormDetails]);
    }
  };

  onPageChange = async (page) => {
    this.setState({ page }, async () => {
      await this.loadFormData(true, true);
    });
  };

  loadFormData = async (
    showLoader = false,
    skipAppending = false,
    resetPagination = false
  ) => {
    if (showLoader) {
      this.setState({
        showLoader: true,
      });
    }
    let page = this.state.page;
    if (resetPagination) {
      this.setState({ page: 1 });
      page = 1;
      this.hasMore = true;
    }
    if (this.formDetail.length > 0) {
      let template = this.selectedTemplate;
      let formInfo = this.formDetail[0];
      let fieldDetails = this.formDetail[1];
      let moduleName = formInfo[0];
      let templateFieldOrders = template[4];
      let tabValue = this.state.tabValue;
      let predefinedCondition = this.predefinedConditionArr[tabValue];
      let params = {
        ENTITY: "Search_by_filter",
        OPERATION: "FIND",
        FORMNAME: this.formname,
        RECORDVALUES: this.state.limit,
        MODULENAME: moduleName,
        FORMTYPE: "",
        "Template name": template[1],
        "Template Id": template[0],
        PAGENUMBER: this.state.page,
        NUMBEROFROW: this.state.limit,
        isOtherApiReq: true,
        isotherapi: true,
        ISAPIREQ: true,
        predefinedCondition: predefinedCondition,
      };
      if (this.searchStr !== "") {
        params = {
          ENTITY: "Search form",
          FORMNAME: this.formname,
          SEARCHFIELDS: this.searchStr,
          PREDEFINED: "",
          PAGENUMBER: page,
          NUMBEROFROW: this.state.limit,
          isOtherApiReq: true,
          isotherapi: true,
          ISAPIREQ: true,
        };
      }
      if (this.state.manualSearchStr != "") {
        params = {
          ENTITY: "FORMPROCESS",
          OPERATION: "FIND",
          FORMNAME: this.formname,
          MODULENAME: moduleName,
          FORMTYPE: "",
          LASTSELECTEDTEMPLATE: template[0],
          PAGENUMBER: this.state.page,
          NUMBEROFROW: this.state.limit,
          SEARCHFIELDS: {
            advanced_search_key: this.state.manualSearchStr,
            STARTC: true,
          },
          isOtherApiReq: true,
          isotherapi: true,
          ISAPIREQ: true,
        };
      }
      let formreponse = await requestApi.processServerRequest(params, "WebV2");
      if (formreponse.issuccess) {
        let formData = formreponse.data;
        if (this.searchStr !== "") {
          formData = formData[0][2];
        }
        let totalCount = formData[1];
        let rowData = formData[2];
        let rowFieldsInfo = formData[3];
        //let listRowFields = rowFieldsInfo[0][3];
        let listFields = await getListFields(fieldDetails, templateFieldOrders);
        //let tempRowData = await this.reArrangeListRows(listRowFields, fieldDetails, rowData);
        this.setState({
          formData: skipAppending
            ? rowData
            : [...this.state.formData, ...rowData],
          listFields: listFields[0],
          fieldsSorting: listFields[1],
          totalCount: totalCount,
          showLoader: false,
        });
      } else if (formreponse.errormsg != "") {
        showToast(formreponse.errormsg, "top-right", "error");
      }
    }
  };

  reArrangeListRows = async (listItem, sortBy) => {
    let viewFields = this.state.listFields;
    let selectedTemplate = this.selectedTemplate;
    let listFieldOrders = "";
    let lfieldLabel = listItem["value"];
    let lfieldName = listItem["id"];
    for (let vf = 0; vf < viewFields.length; vf++) {
      let fieldOrder = viewFields[vf][22];
      let fieldName = viewFields[vf][2];
      let orderBy = 0;
      if (lfieldName == fieldName) {
        if (sortBy == "asc") {
          orderBy = 1;
        } else {
          orderBy = 2;
        }
      }
      listFieldOrders += fieldOrder + "," + orderBy + ",";
    }
    let params = {
      ENTITY: "FORMPROCESS",
      OPERATION: "UPDATESORT",
      FORMNAME: this.formname,
      fieldsortstr: listFieldOrders,
      templateid: selectedTemplate[0],
    };
    await requestApi.processServerRequest(params);
    await this.loadFormData(true, true, true);
  };

  getLeadFormDetails = async () => {
    let appid = getSessionValue("appid");
    let username = getSessionValue("loginusername");

    if (this.formDetail.length > 0) {
      let templates = this.formDetail[4];
      let lastTemplate =
        this.formDetail[8].length > 0 ? this.formDetail[8][0] : [];
      let templateGroups = [];
      let systemTemps = [];
      let publicTemps = [];
      let privateTemps = [];
      let lastSelectedTemplateId =
        lastTemplate.length > 0 ? lastTemplate[2] : "";
      for (let key in templates) {
        let template = templates[key];
        if (lastSelectedTemplateId == template[0]) {
          this.selectedTemplate = template;
        } else if (lastSelectedTemplateId == "") {
          lastSelectedTemplateId = template[0];
          this.selectedTemplate = template;
        }
        if (template[5] == "1") {
          systemTemps.push(template);
        } else if (template[3] == "1") {
          publicTemps.push(template);
        } else {
          privateTemps.push(template);
        }
      }
      templateGroups.push(systemTemps);
      templateGroups.push(publicTemps);
      templateGroups.push(privateTemps);
      this.setState({
        templates: templateGroups,
        selectedTemplate: this.selectedTemplate,
      });
    }
  };

  onTemplateChange = async (template) => {
    this.selectedTemplate = template;
    this.state.manualSearchStr="";
    await this.setState({
      selectedTemplate: template,
    });
    await this.loadFormData(true, true, true);
  };

  handleTabChange = async (e, newTabValue) => {
    await this.setState({
      tabValue: newTabValue,
    });
    await this.loadFormData(true, true, true);
  };

  onRecordSelection = async (isChecked, recordId) => {
    let massSelect = this.state.massSelect;
    if (isChecked) {
      massSelect.push(recordId);
    } else {
      const index = massSelect.indexOf(recordId);
      if (index > -1) {
        // only splice array when item is found
        massSelect.splice(index, 1); // 2nd parameter means remove one item only
      }
    }
    this.setState({
      massSelect,
    });
  };

  onSelectAllRecord = async (isChecked) => {
    let data = this.state.formData;
    let massSelect = [];
    let formIdKey = this.formname + "_id";
    if (isChecked) {
      for (let key in data) {
        let row = data[key];
        let formid = row[formIdKey];
        massSelect.push(formid);
      }
    }
    this.setState({
      massSelect,
    });
  };

  openAddLead = async (e) => {
    //showToast("Not Supported");
    let dataRow = prepareDefaultValueList(this.formDetail);
    this.setState({
      dataRow,
      isRowSelected: false,
    });
    this.openFormModal();
  };

  setSelectedRows = (selectedRows) => {
    this.setState({
      massSelect: selectedRows,
    });
  };

  setMassEditOpen = (selectedRows) => {
    this.setState({
      isMassUpdate: true,
      massSelect: selectedRows,
    });
  };

  setMassEditClose = () => {
    this.setState({
      isMassUpdate: false,
      massSelect: [],
    });
  };

  updateMassFields = async (e, selectedField, dataRow, fieldDetail) => {
    let fieldName = fieldDetail[2];
    let fieldLabel = fieldDetail[3];
    let fieldType = fieldDetail[4];
    let formInfo = this.formDetail[0];
    let moduleName = formInfo[0];
    let fieldValue = dataRow[fieldLabel];
    if (
      fieldType === "ComboBox" ||
      fieldType === "entity_group" ||
      fieldType === "reference"
    ) {
      fieldValue = dataRow[fieldLabel]["value"];
    }
    let fieldValues = {};
    fieldValues[fieldName] = fieldValue;
    let fieldstatus = {};
    fieldstatus[fieldName] = true;
    let auditinfo = {};
    auditinfo["displaystring"] = this.state.massSelect.length + " Records";
    let params = {
      ENTITY: "FORMPROCESS",
      OPERATION: "MASSEDIT",
      FORMNAME: this.formname,
      MODULENAME: moduleName,
      FORMTYPE: "",
      SUBTABLE_INPUTFIELDS: [],
      SUBTABLELINK_INPUTFIELDS: [],
      LINEITEM_INPUTFIELDS: [],
      BASETABLE_INPUTFIELDS: [],
      concurrent_process_confirmed: false,
      ids: this.state.massSelect,
      historyvalues: [],
      fieldvalues: fieldValues,
      fieldstatus: fieldstatus,
      auditinfo: auditinfo,
    };
    let result = await requestApi.processServerRequest(params, "WebV2", "post");
    if (result.issuccess) {
      showToast(
        this.state.massSelect.length + " records updated successfully."
      );
    } else {
      handleErrorResponse(result.errormsg);
    }
  };

  deleteLeads = async (e, isConfirm = false, isForce = false) => {
    if (!isConfirm) {
      await this.toggleModal();
    } else {
      let selectedRowIds = this.state.massSelect;
      let formInfo = this.formDetail[0];
      let moduleName = formInfo[0];
      let params = {
        ENTITY: "FORMPROCESS",
        OPERATION: "DELETE",
        FORMNAME: this.formname,
        MODULENAME: moduleName,
        FORMTYPE: "",
        "Check Reference": isForce,
        FORM_INPUTFIELDS: selectedRowIds,
        auditinfo: { displaystring: selectedRowIds.length + " Records" },
      };
      let deleteresponse = await requestApi.processServerRequest(params);
      if (deleteresponse.issuccess) {
        let deleteRes = deleteresponse.data;
        if (deleteRes != "" && deleteRes != "Active") {
          await this.setState({
            forceErrorMsg: deleteRes,
          });
          await this.toggleNestedModal();
        } else {
          await this.setState({
            massSelect: [],
          });
          showToast(selectedRowIds.length + " records deleted successfully.");
          await this.toggleAllModal();
          await this.loadFormData(true, true, true);
        }
      } else if (deleteresponse.errormsg != "") {
        showToast(deleteresponse.errormsg, "top-right", "error");
      }
    }
  };

  massUpdateFields = async (e) => {};
  openFilterPanel = async (e) => {
    this.toggleSearchModal();
  };
  refreshCurrentPage = async (e) => {
    await this.loadFormData(true, true, true);
  };

  onRowView = async (e, dataRow) => {
    e.preventDefault();
    this.setState({
      dataRow,
      isRowSelected: true,
    });
  };

  openFormModal = () => {
    this.setState({
      isOpen: true,
    });
  };

  closeFormModal = () => {
    this.setState({
      isOpen: false,
    });
  };

  toggleFormModal = () => {
    let isOpen = this.state.isOpen;
    this.setState({
      isOpen: !isOpen,
    });
  };

  handleSearchOperation = async (name, searchTxt) => {
    this.searchStr = searchTxt;
    this.state.manualSearchStr="";
    await this.loadFormData(true, true);
  };

  render() {
    if (this.state.templates.length === 0 || this.state.listFields === 0) {
      return (
        <Common
          pageTitle={"Leads"}
          showLoader={this.state.showLoader}
          mainContent={""}
        />
      );
    }
    let tabValue = this.state.tabValue;
    let data = this.state.formData;
    let fields = this.state.listFields;
    let fieldsSorting = this.state.fieldsSorting;
    let recSelections = this.state.massSelect.length;
    let dataCount = data != undefined ? data.length : 0;
    return (
      <Fragment>
        <BasicLead
          formname={this.formname}
          formData={data}
          listFields={fields}
          templates={this.state.templates}
          onTemplateChange={this.onTemplateChange}
          onPageChange={this.onPageChange}
          setSelectedRows={this.setSelectedRows}
          onMassEditOpen={this.setMassEditOpen}
          onMassEditClose={this.setMassEditClose}
          deleteLeads={this.deleteLeads}
          massUpdateFields={this.massUpdateFields}
          formDetail={this.formDetail}
          page={this.state.page}
          totalCount={this.state.totalCount}
          limit={this.state.limit}
          handleSearchOperation={this.handleSearchOperation}
          selectedTemplate={this.state.selectedTemplate}
          openFilterPanel={this.openFilterPanel}
        />
        <DeleteConfirm
          deleteMsg={
            "The selected records and all related activities will be deleted permanently"
          }
          form={this}
          onDelete={this.deleteLeads}
        />
        <MassUpdate
          isMassUpdate={this.state.isMassUpdate}
          selectedRows={this.state.massSelect}
          onMassEditClose={this.setMassEditClose}
          updateMassFields={this.updateMassFields}
          formname={this.formname}
          formDetail={this.formDetail}
        />
        <CratioConfigModel
          isOpen={this.state.toggleSearchModal}
          headerTxt={"Search Filter"}
          toggleModal={this.toggleSearchModal}
          okBtnCB={this.searchOKCB}
          cancelBtnCB={this.searchCancelCB}
          okBtnTxt={"Apply Filter"}
          cancelBtnTxt={"Cancel"}
          footerComponent={
            <CratioToggle
              value={this.state.matchAll}
              onChange={this.toggleMatchAll}
              label={"Match all of the above"}
            />
          }
          component={
            <SearchPanel
              fieldDetails={this.formDetail[1]}
              onSearchClickRegister={this.searchClickCB}
              filterType={"form"}
            />
          }
        />
      </Fragment>
    );
    return (
      <Common
        pageTitle={"Leads"}
        showLoader={this.state.showLoader}
        mainContent={
          <Fragment>
            <TransitionGroup>
              <CSSTransition
                component="div"
                classNames="TabsAnimation"
                appear={true}
                timeout={0}
                enter={false}
                exit={false}
              >
                <div className="listview-container kv-main-wrapper h100per overflow-none">
                  <Form
                    isNew={true}
                    isOpen={this.state.isOpen}
                    formDetail={this.formDetail}
                    dataRow={this.state.dataRow}
                    toggleFormModal={this.toggleFormModal}
                  />
                  <FormHeader
                    openFilterPanel={this.openFilterPanel}
                    refreshCurrentPage={this.refreshCurrentPage}
                    openAddLead={this.openAddLead}
                    deleteLeads={this.deleteLeads}
                    massUpdateFields={this.massUpdateFields}
                    sortFields={fields}
                    fieldsSorting={fieldsSorting}
                    onSortList={this.reArrangeListRows}
                    onSelectAll={this.onSelectAllRecord}
                    recordsSelected={recSelections}
                    templates={this.state.templates}
                    loadData={this.onTemplateChange}
                    selectedTemplate={this.state.selectedTemplate}
                  />
                  <div className="lead-data-container">
                    <div className={"pr-0 lead-listbar"}>
                      <Card className="main-card mb-3">
                        <Tabs
                          value={tabValue}
                          onChange={this.handleTabChange}
                          aria-label="icon position tabs example"
                        >
                          <Tab
                            icon={<PhoneIcon />}
                            iconPosition="start"
                            label={
                              <>
                                <span className={"text"}>All</span>
                                <span className={"leads-count"}>
                                  ({dataCount})
                                </span>
                              </>
                            }
                          />
                          <Tab
                            icon={<PhoneMissedIcon />}
                            iconPosition="start"
                            label={
                              <>
                                <span className={"text"}>Today</span>
                                <span className={"leads-count"}>
                                  ({dataCount})
                                </span>
                              </>
                            }
                          />
                          <Tab
                            icon={<FavoriteIcon />}
                            iconPosition="start"
                            label={
                              <>
                                <span className={"text"}>Overdue</span>
                                <span className={"leads-count"}>
                                  ({dataCount})
                                </span>
                              </>
                            }
                          />
                          <Tab
                            icon={<PersonPinIcon />}
                            iconPosition="start"
                            label={
                              <>
                                <span className={"text"}>Next</span>
                                <span className={"leads-count"}>
                                  ({dataCount})
                                </span>
                              </>
                            }
                          />
                        </Tabs>
                        <div
                          className={cx("record-select-all  ", {
                            hide: recSelections == 0,
                          })}
                        >
                          <div className={"float-start ml-1point5"}>
                            <span>{recSelections} selected</span>
                          </div>
                          <div className={"float-end mr-2"}>
                            <label className={"mr-1"}>Select All</label>
                            <input
                              onClick={(e) => {
                                this.onSelectAllRecord(e.target.checked);
                              }}
                              title={"Select All"}
                              type={"checkbox"}
                            />
                            <a className={"deselect-all-wrapper ml-2 hide"}>
                              <FontAwesomeIcon icon={faXmark} />
                            </a>
                          </div>
                        </div>
                        <TabPanel
                          className={"lead-data-panel"}
                          value={tabValue}
                          index={tabValue}
                        >
                          {dataCount > 0 ? (
                            <Fragment>
                              {data.map((row, index) => {
                                return (
                                  <DataRow
                                    selectedRecords={this.state.massSelect}
                                    formname={this.formname}
                                    onRecordSelection={this.onRecordSelection}
                                    onRowView={this.onRowView}
                                    row={row}
                                    fields={fields}
                                  />
                                );
                              })}
                            </Fragment>
                          ) : (
                            <NoRecord msg={"No Leads Found."} />
                          )}
                        </TabPanel>
                      </Card>
                    </div>
                    {this.state.isRowSelected && (
                      <div className={cx("pl-0 lead-configbar")}>
                        <Card>
                          <div>
                            <ConfigView
                              formDetail={this.formDetail}
                              profileFields={this.state.profileFields}
                              lead={this}
                              row={this.state.dataRow}
                            />
                          </div>
                        </Card>
                      </div>
                    )}
                  </div>
                  <DeleteConfirm
                    deleteMsg={
                      "The selected records and all related activities will be deleted permanently"
                    }
                    form={this}
                    onDelete={this.deleteLeads}
                  />
                </div>
              </CSSTransition>
            </TransitionGroup>
          </Fragment>
        }
      />
    );
  }
}

const mapStateToProps = (state) => ({
  formDetails: state.ThemeOptions.formDetails,
});

const mapDispatchToProps = (dispatch) => ({
  setFormDetails: (formDetail) => dispatch(setFormDetails(formDetail)),
});

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(Leads);
